const setAreaOfExpertiseLoading = () => ({
  type: 'SET_AREA_OF_EXPERTISE_LOADING',
});

export default setAreaOfExpertiseLoading;
